// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Cy6f","title":"Header_title__2qVJh","side":"Header_side__14Ado"};